module.exports = __webpack_public_path__ + "img/aliado-quinta.580ed657.png";